import Vue from 'vue';
import Vuex from 'vuex';

import { loadModules } from './modules';

const { context, modules } = loadModules();

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  // state: {},
  // mutations: {},
  // actions: {},
});

export default store;

if (module.hot) {
  // Hot reload whenever any module changes.
  module.hot.accept(context.id, () => {
    const { modules } = loadModules();

    store.hotUpdate({
      modules
    });
  });
}
